export const DEFAULT_LANG = "en";

export const LANGUAGES = [
  { label: "English", code: "en", dir: "ltl" },
  { label: "Spanish", code: "es", dir: "ltl" },
  { label: "العربية", code: "ar", dir: "rtl" },
];
